import classNames from "classnames";

type LoaderProps = {
  className?: string;
  size?: "sm" | "md";
  color?: "primary" | "light";
};

const Loader = ({ size = "md", color = "primary", className }: LoaderProps) => {
  return (
    <output
      className={classNames("spinner-border d-block m-auto", className, {
        "spinner-border-sm": size === "sm",
        "text-primary": color === "primary",
        "text-secondary": color === "light",
      })}
    >
      <span className="visually-hidden">Loading...</span>
    </output>
  );
};

export default Loader;
